import { BellIcon, ChevronDownIcon, ChevronUpIcon, EyeIcon, PlusIcon } from '@primer/octicons-react';

import { useEffect, useState } from "react";
import { tbtpApi } from "../../../api/tbtpApi";
import { AnimationConfirm } from "../../../components/confirm";
import { PlaceHolder } from "../../../components/place-holder";
import Button from "../../../components/ui/button";
import { PageBaseStatus } from "../../../models/pageBaseStatus";
import { sf_mucphaithu_insert_from_tbtp_rq } from "../../../models/request/thu-phi/sf_mucphaithu_insert_from_tbtp_rq";
import { sf_hinhthucnopbom } from "../../../models/response/category/sf_hinhthucnopbom";
import { sf_tbtp_viewmodel } from "../../../models/response/tbtp/sf_tbtp";
import { sf_tbtp_res, sf_tbtp_select_by_hocsinh_res } from "../../../models/response/tbtp/sf_tbtp_select_by_hocsinh_res";
import { TBTPEditModal } from "../../tbtp/edit_tbtp_modal";
import styles from "./styles.module.css";
type TBTPListProps = {
    nam_hoc: string,
    ts_hocsinh_id: number,
    onSelected: (data: sf_mucphaithu_insert_from_tbtp_rq) => void,
    status: PageBaseStatus
}
type TBTPItem = {
    sf_tbtp_res: sf_tbtp_res,
    key: number
}
export interface TBTPSelectedItem {
    sf_tbtp_id: number,
    sf_hinhthucnopbom_id: number
}
export const TBTPList = (props: TBTPListProps) => {
    const [dataSource, SetDataSource] = useState<sf_tbtp_select_by_hocsinh_res>();
    const [isLoading, SetIsLoading] = useState<boolean>(false);
    const [selectedItem, SetSeletedItem] = useState<TBTPSelectedItem>({ sf_tbtp_id: 0, sf_hinhthucnopbom_id: 0 })
    const [isShowConfirm, SetIsShowConfirm] = useState<boolean>(false)
    const [tbtpView, SetTBTPView] = useState<sf_tbtp_viewmodel>()
    const [isMainCollapsed, setIsMainCollapsed] = useState<boolean>(false)

    useEffect(() => {
        if (props.nam_hoc > "" && props.ts_hocsinh_id > 0) {
            handleReload();
        }
    }, [props.nam_hoc, props.ts_hocsinh_id])

    useEffect(() => {
        if (props.status === PageBaseStatus.is_need_reload) {
            {
                SetIsShowConfirm(false);
                handleReload();
            }
        }
    }, [props.status])

    const handleReload = async () => {
        SetIsLoading(true);
        let _isLoaded = false;
        const interval_obj = setInterval(() => {
            if (_isLoaded) {
                SetIsLoading(false);
                clearInterval(interval_obj);
            }
        }, 200)
        const res = await tbtpApi.select_by_hocsinh({
            nam_hoc: props.nam_hoc,
            ts_hocsinh_id: props.ts_hocsinh_id
        })
        if (res.is_success) {
            // console.log(res.data)
            SetDataSource({
                ...res.data,
                sf_tbtps: res.data.sf_tbtps.filter((x: any) => x.sf_mucphaithu_id <= 0)
            })
        }
        _isLoaded = true;
    }
    const handleSubmit = () => {
        props.onSelected({
            sf_hinhthucnopbom_id: selectedItem.sf_hinhthucnopbom_id,
            sf_tbtp_id: selectedItem.sf_tbtp_id,
            nam_hoc: props.nam_hoc
        })
    }
    const TBTPItem = (props: TBTPItem) => {
        return (
            <div className={styles.tbtp_item_compact} key={props.key}>
                {/* Header */}
                <div className={styles.tbtp_header}>
                    <div className={styles.tbtp_noi_dung_compact}>
                        {props.sf_tbtp_res.noi_dung}
                    </div>
                    <button
                        className={styles.tbtp_detail_compact}
                        onClick={() => {
                            const data: any = props.sf_tbtp_res;
                            SetTBTPView(data);
                        }}
                    >
                        <EyeIcon size={14} />
                    </button>
                </div>

                {/* Payment methods */}
                <div className={styles.payment_methods_compact}>
                    {props.sf_tbtp_res.sf_hinhthucnopboms
                        .filter(x => x.id > 0)
                        .map((x: sf_hinhthucnopbom) => (
                            <Button
                                key={x.id}
                                id={`btnTBTP${props.sf_tbtp_res.id}.${x.id}`}
                                onClick={() => {
                                    SetSeletedItem({
                                        sf_hinhthucnopbom_id: x.id,
                                        sf_tbtp_id: props.sf_tbtp_res.id,
                                    });
                                    SetIsShowConfirm(true);
                                }}
                                leadingVisual={PlusIcon}
                                text={x.name}
                                variant="default"
                                size="small"
                            />
                        ))}
                </div>
            </div>
        );
    };
    const TBTPItemList = () => {
        return (
            <div className={styles.tbtp_list_container_compact}>
                <div className={styles.tbtp_list_header}>
                    <div className={styles.tbtp_list_caption_compact}>
                        {dataSource && dataSource.sf_tbtps.length > 0 && (
                            <BellIcon size={14} className={styles.bell_icon} />
                        )}
                        Thông báo thu phí ({dataSource?.sf_tbtps.length || 0})
                    </div>
                    <button
                        className={styles.main_collapse_button}
                        onClick={() => setIsMainCollapsed(!isMainCollapsed)}
                    >
                        {isMainCollapsed ? <ChevronDownIcon size={16} /> : <ChevronUpIcon size={16} />}
                    </button>
                </div>

                {!isMainCollapsed && (
                    <div className={styles.tbtp_list_compact}>
                        {dataSource && dataSource.sf_tbtps.map((x: any, idx: number) => {
                            return <TBTPItem sf_tbtp_res={x} key={idx} />
                        })}
                    </div>
                )}
            </div>
        );
    };
    return (
        <div>
            {isLoading && <PlaceHolder line_number={5} />}
            {!isLoading && dataSource && dataSource.sf_tbtps.length > 0 &&
                // <ScrollView width={"100%"} height={200}>
                <div>
                    <TBTPItemList />
                </div>
                // </ScrollView>
            }
            {isShowConfirm && <AnimationConfirm
                animationOf={`#btnTBTP${selectedItem.sf_tbtp_id}.${selectedItem.sf_hinhthucnopbom_id}`}
                onClose={() => { SetIsShowConfirm(false) }}
                onConfirmed={handleSubmit}
                text={"Bạn có chắc chắn muốn tạo chứng từ cho Thông báo thu phí này ?"}
                is_saving={props.status === PageBaseStatus.is_saving}
                text_close_button="Không tạo"
                text_confirm_button="Tạo chứng từ"
                type="success"
            />}
            {tbtpView && <TBTPEditModal
                onCancel={() => { SetTBTPView(undefined) }}
                isReadOnly={true}
                sf_tbtp={tbtpView}
            />}
        </div>
    );
}